'use client';

import { ReactNode } from 'react';
import '../../assets/i18next/i18n';
export default function I18nProvider({ children }: { children: ReactNode }) {
    return <>{children}</>;
}
